class Veranstaltungen {
  constructor() {
    // Constructor logic goes here
    this.veranstaltungen = document.querySelectorAll(".wp-block-post.veranstaltung")
    // console.log("Veranstaltungen", this.veranstaltungen)

    if (!this.veranstaltungen.length) return

    jQuery(document).ready(() => {
      const veranstaltungen = jQuery(".wp-block-post.veranstaltung")
      const contents = veranstaltungen.children(".veranstaltung-content")

      veranstaltungen.children(".veranstaltung-header").click(function () {
        contents.not(jQuery(this).next()).slideUp()
        jQuery(this).next().slideToggle()
        // jQuery(this).toggleClass("open")
      })
    })

    this.veranstaltungen.forEach(veranstaltung => {
      // Code to be executed for each veranstaltung
      // console.log(veranstaltung)
      let metafield = veranstaltung.querySelector(".wp-block-mfb-meta-field-block")
      if (metafield) {
        // console.log("Metafield content: ", metafield.textContent)
        let year = metafield.textContent.substring(0, 4)
        let month = metafield.textContent.substring(4, 6) - 1 // JavaScript months are 0-based
        let day = metafield.textContent.substring(6, 8)
        const date = new Date(year, month, day)
        // console.log("Date: ", date)
        const convertDate = date.toLocaleDateString("de-CH", {
          year: "numeric",
          month: "long",
          day: "numeric"
        })
        // console.log("Converted date: ", convertDate)
        metafield.textContent = convertDate
      }
    })

    // this.events()
  }

  events() {
    // Event listeners go here
    // console.log("Veranstaltungen events")

    window.addEventListener("resize", () => {
      // this.getVeranstaltungenHeight()
    })

    document.addEventListener("DOMContentLoaded", () => {
      // Code to be executed when the DOM is ready
      // console.log("DOM is ready")
      // this.getVeranstaltungenHeight()
    })
  }

  // Class methods go here
}

export default Veranstaltungen
